import { render, staticRenderFns } from "./TrafficSourceTable.vue?vue&type=template&id=680d50f0&"
import script from "./TrafficSourceTable.vue?vue&type=script&lang=js&"
export * from "./TrafficSourceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports